import { useNavigate, useLocation } from "react-router-dom";
import { ToolboxIcon as Toolbox, AirplaneIcon as Airplane, TrophyIcon as Trophy } from "@phosphor-icons/react";

const TABS = [
  { path: "/reportistica/sistemisti", label: "Performance Tecnici", icon: Toolbox, testid: "topmenu-performance-tecnici" },
  { path: "/reportistica/sistemisti/indennita", label: "Trasferte, Reperibilità, Urgenze, Discrezionale e Decurtazioni", icon: Airplane, testid: "topmenu-indennita" },
  { path: "/reportistica/sistemisti/riepilogo-premi", label: "Riepilogo Premi", icon: Trophy, testid: "topmenu-riepilogo-premi" },
];

export function SistemistiReportTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="flex items-stretch gap-1 border-b border-border mb-6 flex-wrap" data-testid="sistemisti-topmenu">
      {TABS.map((t) => {
        const active = pathname === t.path;
        const Icon = t.icon;
        return (
          <button key={t.path} onClick={() => navigate(t.path)}
            className={`flex items-start gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors text-left max-w-[340px] ${active ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"}`}
            data-testid={t.testid}>
            <Icon size={15} className="mt-0.5 flex-shrink-0" /> <span className="leading-tight">{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
